import React from "react";
import {
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormControl,
} from "@mui/material";
import HelpCircleIcon from "../HelpCircleIcon/HelpCircleIcon";
import RenderInputError from "../../pages/Login/RenderInputError/RenderInputError";
import CustomInputProps from "./CustomInputProps";
import "./CustomInput.scss";
import "../../assets/scss/variables.scss";

const CustomInput = (props: CustomInputProps) => {
  return props.withIcon ? (
    <div className="CustomInput">
      <FormControl
        variant="outlined"
        style={{ borderColor:'#0250C1'}}
        fullWidth={props.fullWidth ? props.fullWidth : false}
        className={`${props.space ? "second-input-mt" : ""} ${
          props.formik.touched[props.keyString] &&
          props.formik.errors[props.keyString]
            ? "login-input-error"
            : ""
        }`}
      >
        {/* TODO check  aria-labelledby={props.htmlFor}  or htmlFor*/}
        <InputLabel htmlFor={props.htmlFor}>{props.inputLabel}</InputLabel>
        <OutlinedInput
          type={props.inputType ? props.inputType : "text"}
          id={props.keyString}
          name={props.keyString}
          inputProps={{ maxLength: props.maxLength,"aria-description": props.ariaDescription ? props.ariaDescription : ""}}
          value={props.formik.values[props.keyString]}
          ref={props.inputRef ? props.inputRef : null}
          autoFocus={props.autoFocus}
          aria-describedby={`${props.ariaDescribedby}-sr`}
          // aria-roledescription={props.ariaDescription ? props.ariaDescription : ""}

          // onChange={props.formik.handleChange}
          onChange={(event) => {          
       
              props.formik.setFieldValue(
                props.keyString,
                event.target.value.trim()
              );                       
           
           if(props.isMaskPhone && event.target.value.length == 4 && !event.target.value.includes('-')){          
              props.formik.setFieldValue(      
                props.keyString,        
                event.target.value.match(/.{1,3}/g)?.join('-')
              );}            
          }}
          autoComplete={props.hideInputAutocomplete ? "off" : ""}
          onBlur={props.formik.handleBlur}
          sx={{ borderColor: "#0250C1" ,
          "&.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
            borderColor: "#0250C1"
          },
          "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#0250C1"
          },                    
          "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#0250C1"
          }, }}
          endAdornment={
            <InputAdornment position="end" >
              <IconButton edge="end" role={"presentation"}>
                {props.withTooltip ? (
                  <HelpCircleIcon
                    label={props.tooltipLabel ? props.tooltipLabel : ""}
                  />
                ) : (
                  <props.iconComponent />
                )}
              </IconButton>
            </InputAdornment>
          }
          label={props.inputLabel}
        />
      </FormControl>
      {props.formik.touched[props.keyString] &&
      props.formik.errors[props.keyString] ? (
        <RenderInputError errorLabel={props.formik.errors[props.keyString]} id={props.keyString || ""} inputLabel={props.inputLabel}  />
      ) : null}
    </div>
  ) : (
    <div className="CustomInput">
      <FormControl
        variant="outlined"
        style={{ borderColor:`#0250C1`}}
        fullWidth={props.fullWidth ? props.fullWidth : false}
        className={`${
          props.formik.touched[props.keyString] &&
          props.formik.errors[props.keyString]
            ? "login-input-error"
            : ""
        }`}
      >
        <InputLabel htmlFor={props.htmlFor}>{props.inputLabel}</InputLabel>
        <OutlinedInput
          type={props.inputType ? props.inputType : "text"}
          id={props.keyString}
          name={props.keyString}
          value={props.formik.values[props.keyString]}
          onChange={props.formik.handleChange}
          onBlur={props.formik.handleBlur}
          sx={{ borderColor: "#0250C1" ,
          "&.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
            borderColor: "#0250C1"
          },
          "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#0250C1"
          },                    
          "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#0250C1"
          }, }}
          label={props.inputLabel}
          autoComplete={props.hideInputAutocomplete ? "off" : ""}
          autoFocus={props.autoFocus}
          aria-describedby={`${props.ariaDescribedby}-sr`}
      />
      </FormControl>
      {props.formik.touched[props.keyString] &&
      props.formik.errors[props.keyString] ? (
        <RenderInputError errorLabel={props.formik.errors[props.keyString]} id={props.keyString || ""} inputLabel={props.inputLabel} />
      ) : null}
    </div>
  );
};

export default CustomInput;




// const hebrewToEnglishKeyboardMap:any = {
//   "q": "q",
//   "'": "w",
//   "ק": "e",
//   "ר": "r",
//   "א": "t",
//   "ט": "y",
//   "ו": "u",
//   "ן": "i",
//   "ם": "o",
//   "פ": "p",
//   "[": "]",
//   "{": "}",
//   "]": "[",
//   "}": "{",
//   "\\": "\\",
//   "|": "|",
//   "ש": "a",
//   "ד": "s",
//   "ג": "d",
//   "כ": "f",
//   "ע": "g",
//   "י": "h",
//   "ח": "j",
//   "ל": "k",
//   "ך": "l",
//   "ף": ";",
//   ":": ":",
//   ",": ",",
//   "\"": "\"",
//   "ז": "z",
//   "ס": "x",
//   "ב": "c",
//   "ה": "v",
//   "נ": "b",
//   "מ": "n",
//   "צ": "m",
//   "ת": ",",
//   "<": ">",
//   "ץ": ".",
//   ">": "<",
//   ".": ".",
//   "?": "?"
//  //  ".": "/" 
// };


//  const convertHebrewToEnglish =(input:string) => {
//    let convertedValue = '';
//     for (let i = 0; i < input.length; i++)
//      {
//        const char = input[i]; // Check if the character exists in the Hebrew to English map
//        const convertedChar = hebrewToEnglishKeyboardMap[char] || char;
//         convertedValue += convertedChar;        
//      }      
//      return convertedValue;
//  };